import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class ProvinciaComunali2026 extends Component {
  render() {
    let { regione, provincia } = this.props.params;
    let repoDettaglio = "/elezioni/withub/comunali-2026/comunali/" + regione + "/province/" + provincia + "/" + provincia + ".html";
    let repoFascione = "/elezioni/withub/comunali-2026/comunali/fascione-osservati.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
        <EWH id="ewh-fascione" repo={repoFascione} />
    </div>
    )
  }
}

export default withParams(ProvinciaComunali2026)
